import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined"
import EditIcon from "@mui/icons-material/Edit"
import LinkOffIcon from "@mui/icons-material/LinkOff"
import { Tooltip } from "@mui/material"
import type { BiomeshOperationResponse } from "@phc/common/gen/threatAnalyticsGen"
import {
  ActionButton,
  CardHeader,
  CardRoot,
  CardTitle,
  Row,
  RowGroup,
} from "./shared"

export function OperationCard({
  operation,
  onEdit,
  onUnlink,
  onDelete,
}: {
  operation: BiomeshOperationResponse
  onEdit?: () => void
  onUnlink?: () => void
  onDelete?: () => void
}) {
  return (
    <CardRoot>
      <CardHeader>
        <CardTitle variant="body2Bold">{operation.name}</CardTitle>
        {onEdit && (
          <Tooltip title="Edit operation">
            <ActionButton size="small" onClick={onEdit}>
              <EditIcon fontSize="small" />
            </ActionButton>
          </Tooltip>
        )}
        {onUnlink && (
          <Tooltip title="Remove from this node">
            <ActionButton size="small" onClick={onUnlink}>
              <LinkOffIcon fontSize="small" />
            </ActionButton>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title="Delete permanently">
            <ActionButton size="small" onClick={onDelete}>
              <DeleteOutlineIcon fontSize="small" />
            </ActionButton>
          </Tooltip>
        )}
      </CardHeader>
      <RowGroup>
        {operation.units && operation.units.length > 0 && (
          <Row
            label="Units"
            value={operation.units.map(u => u.name).join(", ")}
          />
        )}
        {operation.contacts && operation.contacts.length > 0 && (
          <Row
            label="Contacts"
            value={operation.contacts
              .map(c => `${c.first_name} ${c.last_name}`)
              .join(", ")}
          />
        )}
      </RowGroup>
    </CardRoot>
  )
}
